import Box from "@mui/material/Box";
import { GridColDef, GridRowsProp, } from "@mui/x-data-grid";
import { observer } from "mobx-react-lite";
import * as React from 'react';
import { useEffect } from 'react';
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import { useApiCall } from "../../../../hooks/useApiCall";
import i18nStore from "../../../../i18n/store";
import filterStore from "../../../CalculationsPage/components/filters/filtersStore";
import {
    createProjectEquipment,
    deleteProjectEquipment,
    deleteUnrelatedEquipments,
    getProjectEquipments,
    updateProjectEquipment
} from "../../api/equipments";
import { getProjectNodes } from "../../api/nodes";
import { EquipmentsInterface } from "../../schemas/equipments";
import { NodeInterface } from "../../schemas/nodes";

import BaseTable, { getHandlerDeleteClick, getHandlerDuplicateClick, TablePropsInterface } from "../BaseTable";
import DeleteUnattachedRowsButton from "../DeleteUnattachedRowsButton";
import { compareById } from "../utils";

import { useMuiEquipmentsColDefs } from "./colDefs";


const EquipmentsTable = observer((props: TablePropsInterface) => {
    const translations = i18nStore.getTranslations;
    const params = useParams();
    const projectId: number = +(params.projectId || 0);

    const [rows, setRows] = React.useState<GridRowsProp>([]);

    const getNodesApi = useApiCall<NodeInterface[]>(() => getProjectNodes(projectId), []);
    useEffect(() => {
        if (projectId) {
            getNodesApi.apiCaller()?.then((nodes: any) => {
                filterStore._setNodes(nodes);
                return nodes;
            });

        }
    }, [projectId]);

    const handlerDuplicateClick: any = getHandlerDuplicateClick(
        projectId,
        rows,
        setRows,
        createProjectEquipment,
    );

    const handlerDeleteClick: any = getHandlerDeleteClick(
        projectId,
        rows,
        setRows,
        deleteProjectEquipment,
    );

    const colDefs: GridColDef[] = useMuiEquipmentsColDefs(
        rows,
        setRows,
        handlerDeleteClick,
        handlerDuplicateClick,
        updateProjectEquipment,
    );

    const getEquipmentsApi = useApiCall<EquipmentsInterface[]>(
        () => getProjectEquipments(projectId).then(equipments => {
            setRows(equipments.sort(compareById).reverse());
            return equipments;
        }),
        [],
    );

    const onDeleteUnrelatedRowsBtnHandler = () => {
        deleteUnrelatedEquipments(projectId).then((deleted_rows: number[]) => {
            const deletedRowsSet = new Set(deleted_rows);
            setRows(prevRows => prevRows.filter((row) => !deletedRowsSet.has(row.id) && row.node_id));
        })
    }

    return (
        <BaseTable
            colDefs={colDefs}
            rows={rows}
            setRows={setRows}
            getRowClassname={(params) => {
                if (!params.row.node_id) {
                    return "WarningFilled";
                }
                return "";
            }}
            getTableApi={getEquipmentsApi}
            tableName={props.tableName}
            tableTitle={translations.equipments}
            createApiFunc={createProjectEquipment}
            updateApiFunc={updateProjectEquipment}
            createEmptyRow={() => {
                return {
                    id: uuidv4(),
                    name: '',
                    u_nom: null,
                    R: null,
                    X: null,
                    R2: null,
                    X2: null,
                    R0: null,
                    X0: null,
                    is_active: true,
                };
            }}
            extraToolbar={
                <Box sx={{flexGrow: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-start", mb: 1}}>
                    <DeleteUnattachedRowsButton
                        onClick={onDeleteUnrelatedRowsBtnHandler}
                        disabled={rows.find(row => !row.node_id) === undefined}
                    />
                </Box>
            }
        />
    );
});

export default EquipmentsTable;
